// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uVVmy","placeholdersHeader":"styles_placeholdersHeader__4-j4L","editorStyle":"styles_editorStyle__1Fv4v","placeholdersBox":"styles_placeholdersBox__1FJgi"};